import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface AgentSelectionToolbarProps {
  selectedCount: number;
  totalCount: number;
  onBulkUpdate: () => void;
  onClearSelection: () => void;
  onSelectAll: () => void;
}

export const AgentSelectionToolbar = ({
  selectedCount,
  totalCount,
  onBulkUpdate,
  onClearSelection,
  onSelectAll,
}: AgentSelectionToolbarProps) => {
  const isAllSelected = selectedCount === totalCount && totalCount > 0;

  return (
    <div className="sticky top-0 z-20 bg-gradient-to-r from-blue-50 to-blue-100 border-b border-blue-200 px-4 py-4 shadow-md">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <span className="text-sm font-medium text-gray-900">
            {selectedCount} of {totalCount} agents selected
          </span>
        </div>

        <div className="flex items-center gap-3">
          <Button
            onClick={onSelectAll}
            variant="outline"
            size="sm"
            className="border-gray-300"
          >
            {isAllSelected ? 'Deselect All' : 'Select All'}
          </Button>
          <Button
            onClick={onBulkUpdate}
            className="bg-genie-primary hover:bg-genie-primary/90 text-white"
            size="sm"
          >
            Bulk Update
          </Button>
          <Button
            onClick={onClearSelection}
            variant="outline"
            size="sm"
            className="border-gray-300"
          >
            <X className="h-4 w-4 mr-1" />
            Clear Selection
          </Button>
        </div>
      </div>
    </div>
  );
};
